import type { QueryClient } from '@tanstack/react-query';
import {
	buildTutorialDemonstracaoMedicalRecord,
	buildTutorialDemonstracaoPatient,
	TUTORIAL_DEMO_MEDICAL_RECORD_ID,
	TUTORIAL_DEMO_PATIENT_ID,
} from './tutorialDemonstracaoMock';

const sessionsQueryKey = (patientId: string) =>
	[
		'sessions',
		true,
		undefined,
		undefined,
		undefined,
		undefined,
		patientId,
		undefined,
		50,
		1,
		undefined,
		undefined,
	] as const;

export function seedTutorialDemonstracaoQueryCache(
	queryClient: QueryClient,
	professionalId: string,
): void {
	const patient = buildTutorialDemonstracaoPatient(professionalId);
	const medicalRecord = buildTutorialDemonstracaoMedicalRecord();

	const emptyMedicalRecordSessions: MedicalRecords.GetMedicalRecordSessionsResponse =
		{
			data: [],
			pagination: {
				total: 0,
				page: 1,
				limit: 20,
				totalPages: 0,
			},
		};

	const emptyPlatformSessions: Sessions.GetSessionsRespose = {
		data: [],
		total: 0,
	};

	queryClient.setQueryData(['patient', TUTORIAL_DEMO_PATIENT_ID], patient);
	queryClient.setQueryData(
		['medical-record', TUTORIAL_DEMO_PATIENT_ID],
		medicalRecord,
	);
	queryClient.setQueryData(
		['medical-record-sessions', TUTORIAL_DEMO_MEDICAL_RECORD_ID, 1, 20],
		emptyMedicalRecordSessions,
	);
	queryClient.setQueryData(
		sessionsQueryKey(TUTORIAL_DEMO_PATIENT_ID),
		emptyPlatformSessions,
	);
}
